import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchAllProductStyles } from 'actions/productdetail/sharing';
import { trackError } from 'helpers/ErrorUtils';
import type { AppDispatch } from 'entrypoints/bootstrapOnClient';

const useFetchAllProductStyles = (productId: string) => {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    const fetchStyles = async () => {
      try {
        await dispatch(fetchAllProductStyles(productId));
      } catch (error: any) {
        trackError('ERROR', 'useFetchAllProductStyles: failed to fetch product styles', error);
      }
    };

    fetchStyles();
  }, [fetchAllProductStyles, productId]);
};

export default useFetchAllProductStyles;
